import React from 'react';

export default class ProtoImg extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: ''
        }
    }

    render() {
        return (
            <div className="col-lg-3 pt-3">
                <div className="img text-center">
                    <img src={this.props.img} alt={this.props.subTitle}/>
                    <span className="text-center">
                        <strong>
                            {this.props.subTitle}
                        </strong>
                    </span>
                </div>
            </div>
        )
    }

}
